import React, {useContext, useEffect, useState} from 'react';
import {useNavigate, useOutletContext} from 'react-router-dom';

import {useTypedSelector} from "@hooks/useTypedSelector";

import TreeList from "@elements/treeList/TreeList";
import {Service} from "@context/map/mutableStore";
import UnitStore from "@context/map/units/unitsStore";

import MonitoringMenu from "@modules/card/menu/MonitoringMenu";

import getListSelected from "@utils/getListSelected";
import {getColorByStatusUnits} from "@utils/getColorByStatusUnit";
import {noneEmpty} from "@utils/noneEmpty";

import {Color} from "@baseTypes/baseType";
import Container from '@elements/container/Container';

import st from './listUnit.module.scss';
import LoadingBox from "@elements/loading/LoadingBox";


const ListUnits = (props: any) => {
  
  let {
    isLoading
  }: any = useOutletContext()
  
  let {
    entities, ids
  } = useTypedSelector(state => state.units)
  
  let [nodes, setNode] = useState<any>([]);

  const service: any = useContext(Service)
  const navigate = useNavigate();

  useEffect(() => {
    setNode(Object.values(entities))
  }, [ids])

  let groupTemp = ({data}: any) => {
    let {name, glid} = data
    let title: string = name !== "." ? name : "Все"
    
    return (
      <div className={st.group}>
        {title}
      </div>
    )
  }
  
  let elementTemp = ({data}: any) => {
    let color = getColorByStatusUnits(data?.dynamic?.unitState)
    return (
      <div className={st.unit}>
        <div className={st.unitStatus}>
          <div className={st.unitPoint} style={{background: color}}/>
        </div>
        <div className={st.unitDescription}>
          <div className={st.unitName}>{data?.glid} </div>
          <div className={st.unitText}> {data?.name}</div>
        </div>
      </div>
    )
  }
  
  let contextMenu = () => [
    {
      name: "Показать на карте",
      action: (params: any) => {
        let selected = getListSelected(params, "UNITS")
        let list = selected.list.map((i: any) => i.glid);
        navigate(`${list.join(":")}/details`, {replace: true})
      }
    },
  
  ]


  if (isLoading) return <LoadingBox></LoadingBox>
  
  return (
    <Container
      blur={true}
      className={`${st.container} ${st.container__content}`}
      color={Color.White}
    >
      <MonitoringMenu/>
      <Container
        className={st.content}
        blur={false}
        radius={true}
      >
        <TreeList
          nodes={nodes}
          group={groupTemp}
          element={elementTemp}
          contextMenu={contextMenu}
        />
      </Container>
    </Container>
  )
}
export default ListUnits

// {
//   name: "Показать трек",
//   action: (params: any) => ""
// },
// {
//   name: "Создать заметку",
//   action: (params: any) => "",
//   tooltip: "что-то паказать"
// },
// {
//   name: "Создать поручение",
//   action: (params: any) => ""
// },
// {
//   name: "-",
// },
// {
//   name: "Добавить групповой план",
//   action: (params: any) => ""
// }
//============================================================================>
// недоделанная функция для получения массива для aggrid
// let prepareRow = (data: any): any => {
//
//   let array: any = []
//   let prepAr = (dat: any) => {
//     let path = []
//     if (dat.data) {
//       //место для получения пути
//       array.push({...dat, data: []})
//       dat.data.forEach((i: any) => prepAr(i))
//     }
//   }
//   row.forEach((item: any)=>prepAr(item))

//   return array
//
// }


//
// let row = [{
//   "employeeId": 101,
//   "employeeName": "Erica Rogers",
//   "jobTitle": "CEO",
//   "employmentType": "Permanent",
//   data: [
//     {
//       "employeeId": 102,
//       "employeeName": "Malcolm Barrett",
//       "jobTitle": "Exec. Vice President",
//       "employmentType": "Permanent",
//       data: [
//         {
//           "employeeId": 103,
//           "employeeName": "Leah Flowers",
//           "jobTitle": "Parts Technician",
//           "employmentType": "Contract"
//         },
//         {
//           "employeeId": 104,
//           "employeeName": "Tammy Sutton",
//           "jobTitle": "Service Technician",
//           "employmentType": "Contract"
//         }
//       ]
//     }
//   ]
// }]


// return noneEmpty(units) ?
//   <div className="ag-theme-alpine"
//        style={{margin: "100px 0 0 0", width: "500px", height: "100%", border: "1px solid red"}}>
//     <AgGridReact
//       // @ts-ignore
//       gridOptions={gridOptions}
//       groupDisplayType={'singleColumn'}
//       rowHeight={40}
//       headerHeight={40}
//     />
//   </div>
//   :
//   <></>


//
// const gridOptions = {
//   columnDefs: [
//     {field: "jobTitle"},
//     {field: "employmentType"}
//   ],
//   rowData: [
//     prepareRow(row)
//   ],
//
//   treeData: true,
//   matchGridData: [],
//   autoGroupColumnDef: {
//     headerName: "Model",
//     field: "model",
//     cellRenderer: 'agGroupCellRenderer',
//     cellRendererParams: {
//       checkbox: true
//     }
//   },
//   defColumn: {
//     width: 150
//   },
//   getDataPath: function (data: any) {
//
//     let array = ["data"];
//     let ar = (ob: any): void => {
//
//       if (ob.data) {
//         array.push("data")
//         ar(ob.data)
//       }
//
//
//     }
//     ar(data)
//     return array
//   },
//
//
//   rowSelection: 'multiple',
//   // onSelectionChanged: onSelectionChanged,
//
// }